"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var PlayerTagsList = /** @class */ (function (_super) {
    __extends(PlayerTagsList, _super);
    function PlayerTagsList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Дата создания',
                dataIndex: _this.props.dataPlayerTags.dk_date_added,
                key: _this.props.dataPlayerTags.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.props.state.getDateTimeFormat())));
                },
                width: 200,
            }, {
                title: 'Игрок',
                key: "v-" + _this.props.dataPlayerTags.dk_usr_player_tag_title,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, _this.props.player.login));
                },
                width: 200,
            }, {
                title: 'Код метки',
                dataIndex: _this.props.dataPlayerTags.dk_usr_player_tag_code,
                key: _this.props.dataPlayerTags.dk_usr_player_tag_code,
                width: 200,
            }, {
                title: 'Название метки',
                dataIndex: _this.props.dataPlayerTags.dk_usr_player_tag_title,
                key: _this.props.dataPlayerTags.dk_usr_player_tag_title,
                width: 200,
            }, {
                title: 'Цвет метки',
                dataIndex: _this.props.dataPlayerTags.dk_usr_player_tag_color,
                key: _this.props.dataPlayerTags.dk_usr_player_tag_color,
                align: "center",
                width: 100,
                render: function (text, record, idx) {
                    return (React.createElement("div", { style: { color: "" + record.usr_player_tag_color } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "fill-drip" }),
                        "\u0426\u0432\u0435\u0442 \u0442\u044D\u0433\u0430"));
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 80
            }
        ];
        return _this;
    }
    PlayerTagsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_PT = this.props.dataPlayerTags.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_AT = this.props.dataAvailTags.Subscribe("*", function (id, data) {
            _this.setState({
                avail_tags: data.data,
            });
        });
        this.setState({
            data: [],
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
        }, function () {
            _this.props.dataPlayerTags.LoadData(_this.props.player.key);
            _this.props.dataAvailTags.LoadData();
        });
    };
    PlayerTagsList.prototype.componentWillUnmount = function () {
        this.props.dataPlayerTags.UnSubscribe(this.SID_PT);
        this.props.dataAvailTags.UnSubscribe(this.SID_AT);
    };
    PlayerTagsList.prototype.onDeleteClick = function (record) {
        this.props.dataPlayerTags.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0422\u044D\u0433 ",
                React.createElement("b", null,
                    "[",
                    record.usr_player_tag_title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    PlayerTagsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.dataPlayerTags.LoadData(_this.props.player.key, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    PlayerTagsList.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            this.props.dataPlayerTags.LoadData(this.props.player.key);
        }
        if (action === "create") {
            this.props.dlgSelectTag.SetTitle("Добавить метку")
                .SetOnCloseClick(function () { _this.props.dlgSelectTag.Close(); })
                .SetViewData(this.state.avail_tags)
                .SetOnSelectClick(function (key, value) {
                _this.props.dataPlayerTags.AddData({
                    app_user_player_tag_id: key,
                    usr_player_id: _this.props.player.key
                }, function () {
                    if (!_this.props.dlgSelectTag.DATA.notAutoCloseDialog) {
                        _this.props.dlgSelectTag.Close();
                    }
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u0422\u044D\u0433 ",
                        React.createElement("b", null,
                            "[",
                            value,
                            "]"),
                        " \u0434\u043B\u044F \u0438\u0433\u0440\u043E\u043A\u0430 ",
                        React.createElement("b", null,
                            "[",
                            _this.props.player.login,
                            "]"),
                        " \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D !"));
                });
            }).Show();
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    PlayerTagsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", create: "Пополнить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0433\u0440\u043E\u043A:"),
                            " [",
                            _this.props.player.login,
                            "]")));
                } })));
    };
    return PlayerTagsList;
}(React.Component));
exports.default = PlayerTagsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/operations/tags/PlayerTagsList.tsx
// module id = 1925
// module chunks = 0